@if (facility) {
<div class="facility-overview-wrapper">
  <div class="description">{{ facility.description }}</div>
  <app-separator></app-separator>
  <app-property-block icon="build" title="Asset type" [content]="facility.assetType"> </app-property-block>
  <app-separator></app-separator>
  <app-property-block icon="domain" title="Facility type" [content]="facility.facilityType"> </app-property-block>
  <app-separator></app-separator>
  <!-- TODO when facility.assignees ready -->
  <app-property-block icon="group" title="Assignees" content="People"> </app-property-block>
</div>
}
